import React from "react";
import Card from "components/card";
import {
    Heart,
} from "lucide-react"

const NoTickets = () => {
    return (
        <Card className="bg-white text-slate-900 flex flex-col gap-6 rounded-2xl border-2 border-dashed border-slate-300">
            <div className="px-6 pb-6 flex flex-col items-center justify-center py-12 text-center">
                <Heart className="w-16 h-16 text-slate-600 mb-4 opacity-50" />
                <h4 className="text-[16px] font-semibold mb-2">
                    No Tickets Found
                </h4>
                <p className="text-[13px] text-slate-600 max-w-sm">
                    Try adjusting your search or filters
                </p>
            </div>
        </Card>
    )
};
export default NoTickets;